// extracted by mini-css-extract-plugin
export default {"Wrapper":"rWidr0o_QkfXFKpkbHqw","center":"qSdla5FkDAxOBbRG8mBu"};